'use client';

import React from 'react';
import { FormText } from '../../base/form';
import { cx } from '../../../utils/cx';

export type MessageBoxType = 'info' | 'success' | 'warning' | 'error';

export type MessageBoxProps = {
    children: React.ReactNode;
    type?: MessageBoxType;
    className?: string;
};

const styles = {
    info: 'bg-utility-user-100',
    success: 'bg-utility-success-100',
    warning: 'bg-utility-warning-100',
    error: 'bg-utility-error-100',
};

/**
 * Renders admin dashboard status messaging with consistent spacing and rich text styles.
 */
const MessageBox: React.FC<MessageBoxProps> = ({ children, type = 'info', className }) => (
    <FormText
        as="div"
        color="secondary"
        className={cx('RomaAdminDashboardMessageBox rounded-lg p-lg', styles[type], className)}
    >
        {children}
    </FormText>
);

export { MessageBox };
